import { ConfigService } from "../ConfigService/config.service"
import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';
import { AuthenticationService } from '../AuthenticationService/authentication.service';
import { InitializationService } from "../Initialization/initialization.service";
import { InitializationModel } from "../Initialization/initialization.model"
import { AuthStatusService } from "../AuthStatusService/auth-status.service"
import { AccountManagerService } from "../AccountManagerService/account.manager.service";
export class InitializationServiceFactory
{
    static create(config: IAppConfig, spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService,
        configService?: ConfigService,
        initializationModel?: InitializationModel,
        authStatusService?: AuthStatusService,
        accountManagerService?: AccountManagerService

    ): InitializationService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);

        return new InitializationService(configService,
                                        authenticationService,
                                        initializationModel,
                                        authStatusService,
                                        accountManagerService,
                                        httpProvider);
    }
}